import appComponent     from './app.component';

import ConfigModule     from './config/config';
import BootstrapModule  from './bootstrap/bootstrap'
import CommonModule     from './common/common';
import ComponentsModule from './components/components';

import getModulesNames  from '@/getModulesNames.helper';

let externalLibrary =  [
    'ngCookies',
    'ui.router',
    'ui.router.stateHelper',
    'ui.dateTimeInput',
    'ui.bootstrap',
    'ui.bootstrap.datetimepicker',
    'daterangepicker',
    'uiSwitch',
    'ngNotify',
    'ngAfx',
    'zumba.angular-waypoints',
    'ui.select',
    'fixed.table.header'
];

angular
  .module('app', externalLibrary.concat(getModulesNames([
      ConfigModule,
      BootstrapModule,
      ComponentsModule,
      CommonModule
  ])))
  .value('$routerRootComponent', 'app')
  .component('app', appComponent);


/** WEBPACK FOOTER **
 ** ./frontend/app.js
 **/